/* ============================================
   NEW PRODUCT GRID FILTERING FUNCTIONALITY
   ============================================ */

(function() {
    'use strict';

    const productGrids = document.querySelectorAll('[data-product-grid]');
    if (productGrids.length === 0) return;

    productGrids.forEach((productGrid) => {
        const filters = productGrid.querySelectorAll('.product-grid__filter');
        const items = productGrid.querySelectorAll('.product-grid__item');
        const viewAllLinks = productGrid.querySelectorAll('.product-grid__view-all');
        const controls = productGrid.querySelector('[data-product-grid-controls]');
        const prevButton = productGrid.querySelector('[data-product-grid-prev]');
        const nextButton = productGrid.querySelector('[data-product-grid-next]');
        const progressLine = productGrid.querySelector('[data-product-grid-progress-line]');
        const grid = productGrid.querySelector('.product-grid__grid');
        const mobilePerView = Number.parseInt(productGrid.getAttribute('data-mobile-products-per-view') || '2', 10);
        const desktopPerView = Number.parseInt(productGrid.getAttribute('data-products-per-view') || '3', 10);
        const enableMobileInfiniteLoop = productGrid.getAttribute('data-mobile-infinite-loop') === 'true';
        const currentPageByCategory = {};

        if (items.length === 0) return;

        function getCategoryItems(category) {
            return Array.from(items).filter((item) => item.getAttribute('data-category') === category);
        }

        function getItemsPerView() {
            if (window.innerWidth >= 992) return Math.max(1, desktopPerView);
            return Math.max(1, mobilePerView);
        }

        function getTotalPages(category) {
            const categoryItems = getCategoryItems(category);
            return Math.max(1, Math.ceil(categoryItems.length / getItemsPerView()));
        }

        function normalizePage(page, totalPages) {
            const canLoop = enableMobileInfiniteLoop && window.innerWidth < 768;
            if (canLoop) {
                if (page < 0) return totalPages - 1;
                if (page >= totalPages) return 0;
            }
            return Math.min(Math.max(page, 0), totalPages - 1);
        }

        function updateControls(category, totalPages) {
            if (controls instanceof HTMLElement) {
                controls.style.display = totalPages > 1 ? 'flex' : 'none';
            }

            const currentPage = currentPageByCategory[category] || 0;
            const progress = ((currentPage + 1) / Math.max(totalPages, 1)) * 100;
            if (progressLine instanceof HTMLElement) {
                progressLine.style.width = `${progress}%`;
            }

            if (prevButton instanceof HTMLButtonElement) {
                const canLoop = enableMobileInfiniteLoop && window.innerWidth < 768;
                prevButton.disabled = !canLoop && currentPage <= 0;
            }
            if (nextButton instanceof HTMLButtonElement) {
                const canLoop = enableMobileInfiniteLoop && window.innerWidth < 768;
                nextButton.disabled = !canLoop && currentPage >= totalPages - 1;
            }
        }

        function renderCategory(category) {
            const categoryItems = getCategoryItems(category);
            const itemsPerView = getItemsPerView();
            const totalPages = getTotalPages(category);
            const currentPage = normalizePage(currentPageByCategory[category] || 0, totalPages);
            currentPageByCategory[category] = currentPage;
            const pageStart = currentPage * itemsPerView;
            const pageEnd = pageStart + itemsPerView;

            filters.forEach((filter) => {
                if (filter.getAttribute('data-filter') === category) {
                    filter.classList.add('product-grid__filter--active');
                } else {
                    filter.classList.remove('product-grid__filter--active');
                }
            });

            items.forEach((item) => {
                const itemCategory = item.getAttribute('data-category');
                if (itemCategory !== category) {
                    item.classList.remove('product-grid__item--active');
                    item.style.display = 'none';
                    return;
                }

                const categoryIndex = categoryItems.indexOf(item);
                const shouldShow = categoryIndex >= pageStart && categoryIndex < pageEnd;
                if (shouldShow) {
                    item.classList.add('product-grid__item--active');
                    item.style.display = '';
                } else {
                    item.classList.remove('product-grid__item--active');
                    item.style.display = 'none';
                }
            });

            if (viewAllLinks.length > 0) {
                viewAllLinks.forEach((link) => {
                    if (link.getAttribute('data-category') === category) {
                        link.classList.add('product-grid__view-all--active');
                    } else {
                        link.classList.remove('product-grid__view-all--active');
                    }
                });
            }

            updateControls(category, totalPages);
        }

        function switchFilter(category) {
            if (typeof currentPageByCategory[category] !== 'number') {
                currentPageByCategory[category] = 0;
            }
            renderCategory(category);
        }

        function getActiveCategory() {
            const activeFilter = productGrid.querySelector('.product-grid__filter--active');
            if (activeFilter) return activeFilter.getAttribute('data-filter');
            return items[0] ? items[0].getAttribute('data-category') : null;
        }

        function bindSwipe() {
            if (!(grid instanceof HTMLElement)) return;

            let startX = 0;
            let startY = 0;
            const threshold = 30;

            grid.addEventListener('touchstart', (e) => {
                if (window.innerWidth >= 768) return;
                const touch = e.changedTouches[0];
                startX = touch.clientX;
                startY = touch.clientY;
            }, { passive: true });

            grid.addEventListener('touchend', (e) => {
                if (window.innerWidth >= 768) return;

                const touch = e.changedTouches[0];
                const deltaX = touch.clientX - startX;
                const deltaY = touch.clientY - startY;
                if (Math.abs(deltaY) > Math.abs(deltaX) || Math.abs(deltaX) < threshold) return;

                const category = getActiveCategory();
                if (!category) return;
                const totalPages = getTotalPages(category);
                const currentPage = currentPageByCategory[category] || 0;
                const nextPage = deltaX < 0 ? currentPage + 1 : currentPage - 1;
                currentPageByCategory[category] = normalizePage(nextPage, totalPages);
                renderCategory(category);
            }, { passive: true });
        }

        function bindArrows() {
            if (prevButton instanceof HTMLButtonElement) {
                prevButton.addEventListener('click', () => {
                    const category = getActiveCategory();
                    if (!category) return;
                    const totalPages = getTotalPages(category);
                    const currentPage = currentPageByCategory[category] || 0;
                    currentPageByCategory[category] = normalizePage(currentPage - 1, totalPages);
                    renderCategory(category);
                });
            }

            if (nextButton instanceof HTMLButtonElement) {
                nextButton.addEventListener('click', () => {
                    const category = getActiveCategory();
                    if (!category) return;
                    const totalPages = getTotalPages(category);
                    const currentPage = currentPageByCategory[category] || 0;
                    currentPageByCategory[category] = normalizePage(currentPage + 1, totalPages);
                    renderCategory(category);
                });
            }
        }

        function initFilters() {
            bindArrows();

            filters.forEach((filter) => {
                filter.addEventListener('click', () => {
                    const filterValue = filter.getAttribute('data-filter');
                    if (!filterValue) return;
                    currentPageByCategory[filterValue] = 0;
                    switchFilter(filterValue);
                });
            });

            const activeFilter = productGrid.querySelector('.product-grid__filter--active');
            const initialCategory = activeFilter
                ? activeFilter.getAttribute('data-filter')
                : (items[0] ? items[0].getAttribute('data-category') : null);

            if (initialCategory) {
                switchFilter(initialCategory);
                bindSwipe();
            }
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initFilters);
        } else {
            initFilters();
        }

        window.addEventListener('resize', () => {
            const activeFilter = productGrid.querySelector('.product-grid__filter--active');
            const filterValue = activeFilter
                ? activeFilter.getAttribute('data-filter')
                : (items[0] ? items[0].getAttribute('data-category') : null);
            if (filterValue) renderCategory(filterValue);
        });

        window.addEventListener('load', () => {
            const activeFilter = productGrid.querySelector('.product-grid__filter--active');
            const filterValue = activeFilter
                ? activeFilter.getAttribute('data-filter')
                : (items[0] ? items[0].getAttribute('data-category') : null);
            if (filterValue) renderCategory(filterValue);
        });
    });
})();
